export default "__VITE_ASSET__BQy2mPzC__"